import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen } from 'lucide-react';
const tomos = [{
  num: '1',
  emoji: '📘',
  title: 'Fundamentos y Test de Campo',
  desc: 'Cómo funciona la fisiología del ciclista amateur. Qué son los kilómetros basura. Cómo establecer tu Punto Cero con el Test de Campo sin tecnología cara.'
}, {
  num: '2',
  emoji: '📙',
  title: 'La Ciencia de la Micro-Sobrecarga',
  desc: 'Los 4 Pilares que transforman tu potencia. Protocolos exactos. Progresión semana a semana. Sesiones completas escritas día por día.'
}, {
  num: '3',
  emoji: '📗',
  title: 'Nutrición de Supermercado',
  desc: 'Geles caseros, isotónicos y barras energéticas con ingredientes de almacén argentino. Por el 5% del costo de los importados.'
}, {
  num: '4',
  emoji: '📕',
  title: 'El Calendario de 12 Semanas',
  desc: 'Exactamente qué hacer cada día durante 12 semanas. Semanas de carga, semanas de descarga, Retest de Campo y Plan de Contingencia.'
}, {
  num: '5',
  emoji: '📒',
  title: 'Mecánica y Biomecánica DIY',
  desc: 'Los 5 tests caseros para tu posición perfecta sin pagar biomecánica. Mecánica de emergencia en ruta. Mantenimiento preventivo de 15 minutos.'
}, {
  num: '6',
  emoji: '📓',
  title: 'Mentalidad de Pelotón y Cierre',
  desc: 'Cómo leer un pelotón, tácticas de viento para rutas argentinas y el protocolo de gestión del sufrimiento cuando el cuerpo pide parar.'
}];
export function TomosSection() {
  return <section className="py-16 px-4 bg-slate-950" data-id="element-264">
      <div className="max-w-2xl mx-auto" data-id="element-265">
        <FadeIn className="text-center mb-12" data-id="element-266">
          <BookOpen className="w-10 h-10 text-amber-500 mx-auto mb-6" strokeWidth={2} data-id="element-267" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white tracking-wide" data-id="element-268">
            LOS 6 TOMOS
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-269">
          {tomos.map((tomo, index) => <FadeIn key={tomo.num} delay={index * 0.1} data-id="element-270">
              <div className="bg-slate-900 border border-slate-800 border-l-4 border-l-amber-500 rounded-r-xl p-6 md:p-8 shadow-md" data-id="element-271">
                <h3 className="text-lg md:text-xl mb-3 leading-snug" data-id="element-272">
                  <span className="mr-2" data-id="element-273">{tomo.emoji}</span>
                  <span className="text-amber-500 font-bold" data-id="element-274">
                    TOMO {tomo.num} —{' '}
                  </span>
                  <span className="text-white font-bold" data-id="element-275">{tomo.title}</span>
                </h3>
                <p className="text-slate-400 leading-relaxed text-base md:text-lg" data-id="element-276">
                  {tomo.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}